var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 39 0)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455DA0",
    d: "M17.403 7.73h2.637v5.44h-2.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214070",
    d: "M18.722 7.73h1.318v5.44h-1.318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.229 14.505v9.918h-7.416a7.904 7.904 0 0 1-6.091 2.885c-2.357 0-4.6-1.07-6.09-2.885H9.99v7.038H.072v-9.128c0-4.316 3.512-7.828 7.829-7.828h4.68a7.893 7.893 0 0 1 6.14-2.947 7.893 7.893 0 0 1 6.14 2.947h7.368z",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.229 14.505v9.918h-7.416a7.904 7.904 0 0 1-6.091 2.885v-15.75a7.893 7.893 0 0 1 6.14 2.947h7.367z",
    fill: "#C0DEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.95 4.5c0 2.481-2.02 4.5-4.5 4.5-1.099 0-3.836-.412-6.342-1.078-2.107-.56-3.543-1.147-4.386-1.807-.842.66-2.278 1.247-4.386 1.807C11.829 8.588 9.092 9 7.995 9a4.505 4.505 0 0 1-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5 1.097 0 3.834.412 6.341 1.078 2.108.56 3.544 1.147 4.386 1.807.843-.66 2.279-1.247 4.386-1.807C25.614.412 28.35 0 29.45 0c2.48 0 4.5 2.019 4.5 4.5z",
    fill: "#00B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.95 4.5c0 2.481-2.02 4.5-4.5 4.5-1.099 0-3.836-.412-6.342-1.078-2.107-.56-3.543-1.147-4.386-1.807v-3.23c.843-.66 2.279-1.247 4.386-1.807C25.614.412 28.35 0 29.45 0c2.48 0 4.5 2.019 4.5 4.5z",
    fill: "#0174F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.531 36.414a20.44 20.44 0 0 0-1.623-2.025l-.963-1.031-.963 1.031a20.44 20.44 0 0 0-1.623 2.025C1.185 38.091.615 39.483.615 40.67A4.335 4.335 0 0 0 4.945 45a4.336 4.336 0 0 0 4.33-4.33c0-1.187-.57-2.58-1.744-4.256z",
    fill: "#00B3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B6EDFE",
    cx: 18.722,
    cy: 4.526,
    r: 4.526
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.628 11.558a3.161 3.161 0 0 0-3.157 3.158v9.9a3.16 3.16 0 0 0 3.157 3.158h4.708V11.558h-4.708z",
    fill: "#99BEF3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214070",
    d: "M36.139 9.678h2.636v19.976H36.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.722 9.053V0a4.531 4.531 0 0 1 4.526 4.526 4.531 4.531 0 0 1-4.526 4.527z",
    fill: "#99BEF3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.4444888c3a1833577bf3f9200a64c251.svg";
export { ForwardRef as ReactComponent };